// ═══ 더보기 동작 — screens/SimpleMore.js(모바일 페이지)와 parts/WhoMenu.js(데스크톱 드롭다운) 공용 ═══
// 두 자리의 동작이 갈라지면 안 되어 한곳에 둔다. 확인 시트는 호출자가 먼저 띄운다.
import { API, getOwnToken } from '../../utils/api';
import { disconnectSocket } from '../../utils/socket';

export var APP_STORE = 'https://apps.apple.com/kr/app/autodex/id6789510320';
export var PLAY_STORE = 'https://play.google.com/store/apps/details?id=kr.autodex.app';

/// '차량관리 화면으로 보기' 확정 — 선택 저장 후 기존 셸로.
export function goFullMode(screenMode, navigate) {
  screenMode.setChoice('full');
  navigate('/main/dashboard');
}

/// 로그아웃 — 서버 세션 정리 후 토큰 삭제·홈으로. 검차 셸 안의 유일한 직접 fetch.
export function logoutSimple(onLogout, navigate) {
  try { disconnectSocket(); } catch (e) { /* 이미 끊김 */ }
  // 다른 계정 토큰(다른 탭 로그인)이면 서버 로그아웃·토큰 삭제 생략 — 이 탭 정리만 (utils/api getOwnToken).
  var token = getOwnToken();
  (token === null ? Promise.resolve() : fetch(API + '/auth/logout', { method: 'POST', headers: { Authorization: 'Bearer ' + token } }))
    .catch(function () {})
    .finally(function () {
      if (token !== null) window.localStorage.removeItem('autodoc_token');
      if (onLogout) onLogout();
      navigate('/');
    });
}
